var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1708 4.99586H17.922V2.5792C17.922 1.5706 17.1014 0.75 16.0928 0.75H2.82552C1.36147 0.75 0.15436 1.86983 0.015014 3.29788C-0.00626676 3.39878 0.00131106 2.49965 0.00131106 16.4261C0.00131106 17.9833 1.26822 19.2503 2.82548 19.2503H18.1708C19.1794 19.2503 20 18.4297 20 17.4211V6.82506C20 5.81646 19.1795 4.99586 18.1708 4.99586ZM2.82552 2.00647H16.0928C16.4086 2.00647 16.6655 2.26341 16.6655 2.57924V4.9959H2.82552C1.98556 4.9959 1.29794 4.33184 1.25962 3.50118C1.2979 2.67049 1.98552 2.00647 2.82552 2.00647ZM18.1708 17.9938H2.82552C1.96106 17.9938 1.25778 17.2905 1.25778 16.4261V5.77618C1.7066 6.07682 2.24592 6.25229 2.82552 6.25229H18.1708C18.4866 6.25229 18.7436 6.50923 18.7436 6.82506V9.37191H14.016C12.4059 9.37191 11.096 10.6818 11.096 12.2919C11.096 13.9019 12.4059 15.2118 14.016 15.2118H18.7436V17.4211C18.7436 17.7369 18.4866 17.9938 18.1708 17.9938ZM18.7436 13.9554H14.016C13.0987 13.9554 12.3524 13.2092 12.3524 12.2919C12.3524 11.3746 13.0987 10.6284 14.016 10.6284H18.7436V13.9554Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.a14046741d2abf0a435808df5f946a59.svg";